import { useCookies } from "react-cookie";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";

interface Props {
  children: React.ReactNode;
}

const ProtectedRoute = ({ children }: Props) => {
  const [cookies] = useCookies(["apiKey"]);
  const navigate = useNavigate();
  const cookiesToken = cookies.apiKey;

  useEffect(() => {
    if (!cookiesToken) {
      navigate("/login", { replace: true });
    }
  }, [cookiesToken, navigate]);

  if (!cookiesToken) return null; 
  return <>{children}</>;
};

export default ProtectedRoute;
